import React from "react";
import * as PropTypes from "prop-types";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
  color: #0000008A;

  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  background-color: #FFFBEC;
  border: 2px solid rgba(0, 0, 0, 0.12);
`;

const ContentRow = styled.div`
  display: flex;
  & .transaction-amount {
    margin-left: auto;
    font-weight: 700;
    &.amount {
      color: red;
    }
    &.limit {
      color: green;
    }
  }
`;

const LimitDetails = ({ transactionType, transactionAmount, transactionLimit, bankName, accountNumberMask, displayDetailsLimit }) => {
  return (
    <div>
      {Boolean(displayDetailsLimit) && <Container>
        <ContentRow>
          <div>{`Your ${transactionType} amount:`}</div>
          <div className="transaction-amount amount">${transactionAmount}</div>
        </ContentRow>
        <ContentRow>
          <div>{`Current allowed ${transactionType}:`}</div>
          <div className="transaction-amount limit">${transactionLimit}</div>
        </ContentRow>
      </Container>}
      <div>{`Selected account: ${bankName} ••••••${accountNumberMask}.`}</div>
    </div>
  );
};

LimitDetails.propTypes = {
  transactionType: PropTypes.string,
  transactionAmount: PropTypes.number,
  transactionLimit: PropTypes.number,
  bankName: PropTypes.string,
  accountNumberMask: PropTypes.string,
};

LimitDetails.defaultProps = {
  transactionType: null,
  transactionAmount: null,
  transactionLimit: null,
  bankName: null,
  accountNumberMask: null,
};

export default LimitDetails;
